export const canInsertStatement = () => () => {
    return function (node, statement) {
        if (! this.actions.canInsertChild(node)) {
            return false
        }

        const _n = this.nodeProxy(node)
        return _n.canInsertStatement?.(statement)
    }
}

export const insertStatement = () => () => {
    return async function (nodes, statement) {
        await this.BizNode.AR.onInsertCommon(
            this, nodes, {type: 'statement', statement}
        )
    }
}
